import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-column-list",
  templateUrl: "./column-list.component.html",
  styleUrls: ["./column-list.component.scss"],
  standalone: false,
})
export class ColumnListComponent implements OnInit, OnDestroy {
  @Input() objects$: Observable<object[]>;
  @Input() textProperty: string;
  @Input() textProperty2: string;
  @Input() sortAsc = true;
  @Output() clickObject: EventEmitter<object> = new EventEmitter();
  @Output() clickObjScrollbar: EventEmitter<object> = new EventEmitter();

  private subs: Subscription[] = [];

  objects: object[];
  objectsCurrentPage: object[];

  previousVisible = false;
  nextVisible = false;
  currentPage = 0;
  nbPage = 0;
  itemPerPage = 14;

  public kioskMode = false;
  constructor() {}

  ngOnInit(): void {
    this.kioskMode = environment.kioskMode;

    this.subs.push(
      this.objects$.subscribe((_) => {
        if (_ === undefined) return;

            // ← Reset pagination à chaque nouveau jeu de données
        this.currentPage = 0;
        this.previousVisible = false;
        this.nextVisible = false;
        this.nbPage = 0;
        
        if (this.sortAsc) {
          this.objects = _.slice().sort((a, b) =>
            a[this.textProperty] > b[this.textProperty] ? 1 : -1,
          );
        } else {
          this.objects = _.slice();
        }

        if (this.kioskMode) {
          // Pagination active en mode kiosk
          const nbElements = this.objects.length;
          this.nbPage = Math.ceil(nbElements / this.itemPerPage);
          if (this.nbPage > 1) this.nextVisible = true;
          this.fillPage();
        } else {
          // Home : tout afficher sans pagination
          this.objectsCurrentPage = this.objects;
          this.nbPage = 1;
        }
      }),
    );
  }
  fillPage() {
    const startElem = this.currentPage * this.itemPerPage;
    const endElem = startElem + this.itemPerPage;
    this.objectsCurrentPage = [];
    this.objectsCurrentPage = this.objects.slice(startElem, endElem);
  }
  onClickObject(object) {
    this.clickObject.emit(object);
  }
  previous() {
    this.currentPage--;
    this.fillPage();

    this.nextVisible = true; // ← toujours visible quand on recule

    if (this.currentPage == 0) {
      this.previousVisible = false;
    }
  }
  next() {
    this.previousVisible = true;
    this.currentPage++;
    this.fillPage();

    if (this.currentPage == this.nbPage - 1) this.nextVisible = false;
  }
  ngOnDestroy(): void {
    this.subs.forEach((_) => _.unsubscribe());
  }
}
